import ValueAssumed from './ValueAssumed'

export default ValueAssumed
